import { Timeline, Text } from "@mantine/core";
import { Container, Grid, Title, List } from "@mantine/core";
import { Element } from "react-scroll";
import classes from "./Resume.module.css"

export default function Demo() {
  return (
    <Element name="resume">
      <Container my="md">
        <Grid>
          <Grid.Col  span={{ base: 12, xs: 6 }}>
            <Title mb="md" order={1}>
              Experiences
            </Title>
            <Timeline active={5} bulletSize={60} lineWidth={2}>
              <Timeline.Item bullet="2023" title="PT. Teman Digital Bersama">
                <Text c="dimmed">Full Stack Javascript Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item>Develop HRIS admin</List.Item>
                  <List.Item>Develop SSO System</List.Item>
                  <List.Item>Develop ERP System</List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2023 - Now
                </Text>
              </Timeline.Item>

              <Timeline.Item
                bullet="2022"
                title="PT. Kreasi Informatika Mandiri"
              >
                <Text c="dimmed">Web Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item>Develop Mayora Web Application</List.Item>
                  <List.Item>Develop Motul Web Application</List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2022 - Now
                </Text>
              </Timeline.Item>

              <Timeline.Item bullet="2022" title="PT. To Be True">
                <Text c="dimmed">Full Stack Laravel Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item  className={classes.listItem}>
                    Part Time Work at PT. To Be True, develop Logistics system
                    (ex menu: smu outgoing, smu incoming, debt, receivables, and
                    report)
                  </List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2022
                </Text>
              </Timeline.Item>

              <Timeline.Item bullet="2021" title="PT. Indospring Tbk">
                <Text c="dimmed">Back End Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item>Ecommerce Koperasi</List.Item>
                  <List.Item>Rest API</List.Item>
                  <List.Item>Server Configuration using vps ubuntu</List.Item>
                  <List.Item>
                    Part Time Work at PT. Indospring Tbk, develop REST-API for
                    PT. Indospring Tbk Apps and Website using Laravel. (ex: e
                    commerce such as sales, purchases, stock taking, damaged and
                    lost goods also monitoring dashboard)
                  </List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2021 - 2022
                </Text>
              </Timeline.Item>

              <Timeline.Item bullet="2021" title="Burning Room">
                <Text c="dimmed">Full Stack Laravel Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item>
                    Freelance Work at Burningroom Technology, develop ERP system
                    starting from production, warehouse, online and offline
                    sales
                  </List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2021 - 2022
                </Text>
              </Timeline.Item>

              <Timeline.Item bullet="2021" title="PT. Sinar Indra Nusa Jaya Gresik ">
                <Text c="dimmed">Back End Developer</Text>
                <List size="sm" className={classes.listContainer}>
                  <List.Item>
                    Freelance Work at PT. Sinar Indra Nusa Jaya Gresik, develop
                    REST-API for Sinar Indra Nusa Jaya Apps and Website using
                    Laravel. (ex: transaction data and monitoring dashboard)
                    Laravel Backend Developer Rest API Freelance Work at PT.
                    Sinar Indra Nusa Jaya Gresik, develop REST-API for Sinar
                    Indra Nusa Jaya Apps and Website using Laravel. (ex:
                    transaction data and monitoring dashboard)
                  </List.Item>
                </List>
                <Text size="sm" mt={4}>
                  2020 - 2021
                </Text>
              </Timeline.Item>
            </Timeline>
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6 }}>
            <Title mb="md" order={1}>
              Educations
            </Title>
            <Timeline active={3} bulletSize={60} lineWidth={2}>
              <Timeline.Item
                bullet="2018"
                title="Universitas Dinamika (stikom surabaya)"
              >
                <Text c="dimmed" size="sm">
                  S1 Sistem Informasi
                </Text>
                <Text size="xs" mt={4}>
                  2018 - 2022
                </Text>
              </Timeline.Item>
            </Timeline>
          </Grid.Col>
        </Grid>
      </Container>
    </Element>
  );
}
